<div class="container">
  <i class="ui-icon-lock"></i>
  <strong>Unauthorized</strong>
</div>
